// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__wVY8q","spin":"styles_spin__4DHpt"};